import { render, staticRenderFns } from "./systemMessage.vue?vue&type=template&id=1e8e7cfa&scoped=true&"
import script from "./systemMessage.vue?vue&type=script&lang=js&"
export * from "./systemMessage.vue?vue&type=script&lang=js&"
import style0 from "./systemMessage.vue?vue&type=style&index=0&id=1e8e7cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e7cfa",
  null
  
)

export default component.exports